import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DateDisplay } from "../../../ui/DateDisplay/DateDisplay";
import { Placeholder } from "../../../ui/Placeholder";

export const CartStatus: FunctionComponent<{
  orderCreatedTimestamp: string;
  orderId: null | string;
}> = ({ orderCreatedTimestamp, orderId }) => {
  const { t } = useTranslation();
  return (
    <div className="text-xs md:text-sm flex space-x-2 md:space-x-4">
      <div className="flex space-x-1">
        <span className="font-thin text-ink-2">{t("cart.reference")}:</span>
        <strong>
          <Placeholder loading={!orderId}>#{orderId}</Placeholder>
        </strong>
      </div>
      <div className="flex space-x-1">
        <span className="font-thin text-ink-2">{t("cart.date")}:</span>
        <strong>
          <Placeholder loading={!orderCreatedTimestamp}>
            <DateDisplay>{orderCreatedTimestamp}</DateDisplay>
          </Placeholder>
        </strong>
      </div>
    </div>
  );
};
